import { createMutation } from '@tanstack/svelte-query';
import { createLoad, createLoads, deleteLoad, updateLoad } from '$lib/api/load';
import {
	invalidateAfterLoadCreate,
	invalidateAfterLoadDelete
} from '$lib/state/invalidation';
import { getUnitScope, resolveScope, type ScopeFn } from '$lib/queries/scope';
import type { LoadRequest, LoadResponse } from '$lib/types/load';

export const createLoadMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<LoadResponse, Error, LoadRequest>(() => ({
		mutationFn: (request) => createLoad(request),
		onSuccess: () => invalidateAfterLoadCreate(resolveScope(scope))
	}));

export const createLoadsMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<LoadResponse[], Error, LoadRequest & { count: number }>(() => ({
		mutationFn: (request) => createLoads(request),
		onSuccess: () => invalidateAfterLoadCreate(resolveScope(scope))
	}));

export const updateLoadMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<LoadResponse, Error, { id: number; request: LoadRequest }>(() => ({
		mutationFn: ({ id, request }) => updateLoad(id, request),
		onSuccess: () => invalidateAfterLoadCreate(resolveScope(scope))
	}));

export const deleteLoadMutation = (scope: ScopeFn = getUnitScope()) =>
	createMutation<void, Error, number>(() => ({
		mutationFn: (id) => deleteLoad(id),
		onSuccess: () => invalidateAfterLoadDelete(resolveScope(scope))
	}));
